export const dataFields = {
  Nome: 'no_profissional',
  CNS: {
    field: 'nu_cns',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CPF: {
    field: 'nu_cpf',
    callback: (value) => {
      return value !== '' ? `​  ​​${value.toString()}` : ''
    },
  },
  CBO: {
    callback: (item) => {
      return (
        item.lotacoes
          ?.map((lotacao) => (lotacao.no_cbo ? lotacao.no_cbo : ''))
          .join('\n') || ''
      )
    },
  },
  CNES: {
    callback: (item) => {
      return (
        item.lotacoes
          ?.map((lotacao) => (lotacao.nu_cnes ? `​  ​​${lotacao.nu_cnes}` : ''))
          .join('\n') || ''
      )
    },
  },
  'Unidade de saúde': {
    callback: (item) => {
      return (
        item.lotacoes
          ?.map((lotacao) =>
            lotacao.no_unidade_saude ? lotacao.no_unidade_saude : ''
          )
          .join('\n') || ''
      )
    },
  },
  INE: {
    callback: (item) => {
      return (
        item.lotacoes
          ?.map((lotacao) => (lotacao.nu_ine ? `​  ​​${lotacao.nu_ine}` : ''))
          .join('\n') || ''
      )
    },
  },
  EQUIPE: {
    callback: (item) => {
      return (
        item.lotacoes
          ?.map((lotacao) => (lotacao.no_equipe ? lotacao.no_equipe : ''))
          .join('\n') || ''
      )
    },
  },
}
